/*
 * Copyright (C) 2024 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

// Matches an ArcLight Fixed Terminal Identifier, which is the last two octets of a terminal's satellite IP address.
export const FTI_PATTERN = '(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d))';

// Matches a MAC address
export const MAC_ADDR_PATTERN = '([0-9A-Fa-f]{2}[:\\-]){5}([0-9A-Fa-f]{2})';

// Matches a CDP asset ID
export const CDP_ASSET_ID_PATTERN = '[a-zA-Z0-9_\\-]+';
